module.exports = __webpack_public_path__ + "img/logo-innogement-black-sinclaim.2d05d7f7.svg";